import { render, staticRenderFns } from "./TwitterIcon.vue?vue&type=template&id=2df2a562&functional=true&"
var script = {}
import style0 from "./TwitterIcon.vue?vue&type=style&index=0&lang=stylus&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  true,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("c:\\source\\adViewer\\AdViewer.Web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2df2a562')) {
      api.createRecord('2df2a562', component.options)
    } else {
      api.rerender('2df2a562', component.options)
    }
    module.hot.accept("./TwitterIcon.vue?vue&type=template&id=2df2a562&functional=true&", function () {
      api.rerender('2df2a562', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "wwwroot/src/components/TwitterIcon.vue"
export default component.exports